import React, { useState, useEffect } from "react";
import { useExam } from "../../context/ExamContext";
import parse from "html-react-parser";

function InputCompletion({ set }) {
  const { updateAnswer, answers } = useExam();
  const [inputs, setInputs] = useState({});
  const { activeQuestion, setActiveQuestion } = useExam();

  useEffect(() => {
    if (!set.commonQuestion) return;

    const newInputs = answers.reduce((acc, curr) => {
      acc[curr.questionNumber] = curr.answer || "";
      return acc;
    }, {});

    setInputs(newInputs);
  }, [set.commonQuestion, answers]);

  useEffect(() => {
    const nextInput = document.querySelector(
      `[data-question='${+activeQuestion}']`
    );
    if (nextInput) nextInput.focus();

  }, [activeQuestion])



  const handleInputChange = (questionNumber, value) => {
    // setActiveQuestion(Number(questionNumber) + 1);

    setInputs((prev) => ({
      ...prev,
      [questionNumber]: value,
    }));
  };

  const handleBlurOrSubmit = (questionNumber) => {
    if (
      inputs[questionNumber] !==
      answers.find((a) => a.questionNumber == questionNumber)?.answer
    ) {
      updateAnswer({
        questionNumber: +questionNumber,
        answer: inputs[questionNumber] || "",
      });
    }
  };

  const handleKeyDown = (e, questionNumber) => {
    if (e.key === "Enter" || e.key === "Tab") {
      e.preventDefault();
      handleBlurOrSubmit(questionNumber);
      const nextInput = document.querySelector(
        `[data-question='${+questionNumber + 1}']`
      );
      if (nextInput) nextInput.focus();
    }
  };

  const handleClick = (questionNumber) => {
    setActiveQuestion(questionNumber)
  };

  const renderTextWithInputs = (text) => {
    const parsedContent = parse(text.replace(/\*(\d+)\*/g, (match, p1) => {
      return `<input class='droppable' data-question='${p1}' placeholder='${p1}'/>`;
      // style='text-align: center; background-color: white; color: black; border: 1px solid gray; margin: 0 5px; min-width: 50px; padding: 3px 10px;'/>`;
    }), {
      replace: (domNode) => {
        if (domNode.attribs && domNode.attribs.class === "droppable") {
          const questionNumber = domNode.attribs["data-question"];
          return (
            <input
              key={questionNumber}
              data-question={questionNumber}
              style={{
                textAlign: 'center',
                backgroundColor: "var(--background-color)",
                color: 'var(--text-color)',
                border: '1px solid var(--text-color)',
                margin: '3px 5px',
                minWidth: "50px",
              }}
              value={inputs[questionNumber] || ""}
              onChange={(e) => handleInputChange(questionNumber, e.target.value)}
              onBlur={() => handleBlurOrSubmit(questionNumber)}
              onKeyDown={(e) => handleKeyDown(e, questionNumber)}
              onClick={() => handleClick(+questionNumber)}
              placeholder={questionNumber}
            />
          );
        }
      },
    });
    return <div style={{ color: "var(--text-color)" }}>{parsedContent}</div>;
  };

  return (
    <div className="input-completion" style={{ fontSize: "1rem", color: "white" }}>
      {set.commonQuestion && renderTextWithInputs(set.commonQuestion)}
    </div>
  );
}

export default InputCompletion;
